import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import { stylePropType } from 'utils/propTypes';

function ActionHeader({ title, titleStyle, children, buttonStyle }) {
    return (
        <>
            {title && (
                <Typography
                    div="fv-prize-title-text"
                    css={[headerStyle, css(titleStyle)]}
                    variant="h5"
                >
                    {title}
                </Typography>
            )}

            <div id="fv-prize-action-button" css={[buttonContainerStyle, css(buttonStyle)]}>
                {children}
            </div>
        </>
    );
}

ActionHeader.propTypes = {
    title: PropTypes.string,
    titleStyle: stylePropType,
    children: PropTypes.node
};

export default ActionHeader;

const headerStyle = css`
    margin: 8px 0 16px 0px;
    text-align: center;
    font-weight: 500;
`;

const buttonContainerStyle = css`
    margin: 16px 0;
`;
